var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AbstractMdg2Request } from './AbstractMdg2Request';
var KeyValueRequest = (function (_super) {
    __extends(KeyValueRequest, _super);
    function KeyValueRequest(scope, key, subscribe) {
        if (subscribe === void 0) { subscribe = false; }
        var _this = _super.call(this, KeyValueRequest.NAME, KeyValueRequest.VERSION) || this;
        _this.members.scope = scope;
        _this.members.key = key;
        if (subscribe) {
            _this.header.setFlag('add_subscription');
        }
        return _this;
    }
    KeyValueRequest.NAME = 'KeyValueRequest';
    KeyValueRequest.VERSION = 1;
    return KeyValueRequest;
}(AbstractMdg2Request));
export { KeyValueRequest };
//# sourceMappingURL=KeyValueRequest.js.map